import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import RewardList from './pages/Rewards/RewardList';
import RewardForm from './pages/Rewards/RewardForm';
import Analytics from './pages/Analytics/Analytics';
import Settings from './pages/Settings/Settings';
import { BrandingProvider } from './contexts/BrandingContext';

function App() {
  const isAuthenticated = !!localStorage.getItem('partnerToken');

  return (
    <BrandingProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          {isAuthenticated ? (
            <Route path="/" element={<Layout />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="rewards" element={<RewardList />} />
              <Route path="rewards/new" element={<RewardForm />} />
              <Route path="rewards/:id/edit" element={<RewardForm />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          ) : (
            <Route path="*" element={<Navigate to="/login" replace />} />
          )}
        </Routes>
      </Router>
    </BrandingProvider>
  );
}

export default App;
